import { axios } from '@/utils/request'

export function treeList (params) {
  return axios({
    url: '/purchase/pageTree',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function materialList (params) {
  return axios({
    url: '/purchase/pageMaterial',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function assetList (params) {
  return axios({
    url: '/purchase/pageAsset',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function getTreeObj (id) {
  return axios({
    url: `/purchase/Tree/${id}`,
    method: 'GET'
  })
}

export function getMaterialObj (id) {
  return axios({
    url: `/purchase/Material/${id}`,
    method: 'GET'
  })
}

export function getAssetObj (id) {
  return axios({
    url: `/purchase/Asset/${id}`,
    method: 'GET'
  })
}

export function putTreeObj (params) {
  return axios({
    url: `/purchase/updateTree`,
    method: 'POST',
    data: {
      ...params
    }
  })
}

export function putMaterialObj (params) {
  return axios({
    url: `/purchase/updateMaterial`,
    method: 'POST',
    data: {
      ...params
    }
  })
}

export function putAssetObj (params) {
  return axios({
    url: `/purchase/updateAsset`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
